import { render, staticRenderFns } from "./color-hue-slider.vue?vue&type=template&id=32cd1ecc"
import script from "./color-hue-slider.vue?vue&type=script&lang=js"
export * from "./color-hue-slider.vue?vue&type=script&lang=js"
import style0 from "./color-hue-slider.vue?vue&type=style&index=0&id=32cd1ecc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports